














import { Component, Vue } from "vue-property-decorator";
import Tools from "./tools.vue";
import Docs from "./docs.vue";

@Component({
  name: "CToolsDoc",
  components: {
    Tools,
    Docs
  }
})
export default class CTabs extends Vue {
  private tabIndex = 0;
}
